// extracted by mini-css-extract-plugin
export default {"languageLink":"Language__languageLink--9vA","icon":"Language__icon--3_y","language":"Language__language--Htd"};